const VERSION = 'DEV.25.07.03 (4.57.2)';
export const environment = {
  production: true,
  version: VERSION,
  showConsoleLog: false,
  showExpandCard: false,
  RECONNECT_INTERVAL: 5000,
  RECONECT_ATTEMPTS: 7,
  delay_quote: '1000',
  delay_book: '1000',
  delay_book_aggregated: '1000',
  delay_book_business: '1000',
  SESSION_TIMEOUT_ALERT: 60000, // 1min before reset timeout
  SESSION_TIMEOUT: 1800000, // 30 min
  CONNECTION_INTERVAL: 1000,
  MIN_REFRESH_TOKEN_INTERVAL: 5,
  VALID_USER_INTERVAL: 10000, // 5000 = 5seg
  CONFIG_FILE: 'assets/config/env.json',
  LOGIN_TYPE: 'LoginIAM',
  LOGIN_SERVICE: 'IAMAuthStrategy',
  WHITELABEL: 7,
  BROKER: 'FCSTONE',
  BROKER_PATH: 'stonex',
  BASE_HREF: '/',
  isDev: true,
  SUITABILITY_OMS: true,
  loginDuplicateNegotiation: true,
  VALIDATE_USER_TOKEN: true,
  BASE_URL_REGISTRATION_REPOSITORY: 'https://web-qa.plataformafasttrade.com.br',
  IDENTITY_PROVIDER_URL: 'https://sso-qa.plataformafasttrade.com.br',
  CLIENT_ID: 'storeoidc-local',
  POST_LOGIN_REDIRECT_URL: 'http://localhost:4200/login',
  POST_LOGOUT_REDIRECT_URL: 'http://localhost:4200/login',
  APP_SCOPES: 'http://localhost:4200/',
  WEB_FEEDER_BASE_REST_URL: 'https://api-qa.cedrotech.com/bff-api/webfeeder',
  WEB_FEEDER_BASE_WOS_URL: 'wss://wfportal-qa.cedrotech.com/ws',
  FORGOT_PASSWORD_URL: 'https://sso-dev.plataformafasttrade.com.br/account/password/forgot',
  INCLUDE_ORIGIN_IN_FORGOT_URL: true,
  WEBFEEDER: {
    URL_WEB_FEEDER_FACADE: 'wss://webfeeder-qa.plataformafasttrade.com.br/ws',
    URL_WEB_FEEDER_WSO2: '',
    URL_WEB_FEEDER_ADAPTER: '',
  },
  API_URLS: {
    WEBFEEDER_REST_API_FACADE: 'https://web.plataformafasttrade.com.br/facade',
    FAST_TRADE_BFF_API: 'https://api-qa.plataformafasttrade.com.br/bff-api',
    WORKSPACE_REST_API_FACADE: '/api',
    WEBFEEDER_REST_API_WSO2: '',
    WORKSPACE_REST_API_WSO2: '',
    CEDRO_ACCOUNT_API_WSO2: '',
    WEBFEEDER_REST_API_ADAPTER_AUTH: '',
    WEBFEEDER_REST_API_ADAPTER_WSO2: '',
    WORKSPACE_REST_API_ADAPTER: '',
    ELETRONIC_SIGNATURE_API_ADAPTER: '',
    TERM_SUITABILITY_API_ADAPTER: '',
    SAVE_CHART_API: '/api/grafico/1.1',
    USER_API: 'https://api-dev.plataformafasttrade.com.br/user-api',
    STORE_URL: 'https://store.plataformafasttrade.com.br',
    FAST_MARKET: 'https://plataformafasttrade.com.br',
    ADDRESS_VIA_CEP_API: 'https://api.plataformafasttrade.com.br/user-api/register/postal_code',
    REDIRECT_LOGOUT: '/login',
    REDIRECT_LOGIN: '/login',
  },
  PATHS: {
    WEBFEEDER_ADAPTER: '',
    TRADINGVIEW_ADAPTER: '',
    WEBFEEDER_WSO2: '',
    TRADINGVIEW_WSO2: '',
    USER_IDENTITY_WSO2: '',
    PORTAL_BUSINESS_WSO2: '',
    REGISTRATION_SYSTEM_SUITABILITY: '',
  },
  SYSTEM_VARIABLES: {
    ORDER_HISTORY_FILTER_RANGE: 30,
    EXTRACT_FINANCIAL_FILTER_RANGE: 30,
    MODAL_NEWS_FILTER_RANGE: 30,
    GOOGLE_TAG_MANAGER_ID: 'GTM-PNRPKXL',
    BROKERAGE_VALUE: '',
    NEWS_AGENCY: '[{"value":11,"desc":"Investimentos e Notícias"},{"value":1,"desc":"CEDRO"},{"value":3,"desc":"BOVESPA"},{"value":4,"desc":"BMF"}]',
    REGISTER_IDENTITY: true,
  },
  AFTER_LOGIN_MESSAGE: {
    TITLE: '',
    CONTENT: '',
    EFFECTIVE_DATE: '',
  },
  SpecialCharacters: {
    UserName: '.@_*-',
    Symbol: '-',
  },
  formats: {
    custody: {
      averagePrice: null,
    },
  },
  OAUTH_ALLOWED_URLS: ['https://api-qa.cedrotech.com', 'https://apis-portal-uat.stonex.dev', 'https://apis-portal.stonex.com', '/workspace-api', '/api', '/webfeeder'],
  SIGN_TERM_SUITABILITY_IN_BUY: true,
  SIGN_TERM_SUITABILITY_IN_SELL: true,
  ALWAYS_RE_SIGN_TERM_SUITABILITY_IN_BUY: false,
  ALWAYS_RE_SIGN_TERM_SUITABILITY_IN_SELL: false,
  SENTRY_CODE: '',
  SHOW_FAST_BILLET_CONFIRMED_ORDER: false,
  RESET_BILLET_CONFIRMED_ORDER: false
};

// WHITELABEL:

// Ambiente: 1 - API - (CEDRO) - LoginS
// Ambiente: 2 - ADAPTER - (PI) - LoginA
// Ambiente: 3 - WSO2 - (RB) - LoginW
// Ambiente: 4 - WSO2 - (CEDRO) - LoginW
// Ambiente: 5 - API (FAST TRADE - DEMO) - LoginS
// Ambiente: 6 - ADAPTER - (DAYCOVAL) - LoginA
// Ambiente: 7 - API - (STONEX) - LoginO
// Ambiente: 8 - WSO2 - (TRINUS) - LoginW
// Ambiente: 9 - ADAPTER - (EMPIRICUS) - LoginA
// Ambiente: 10 - API - (RANKING) - LoginS
// Ambiente: 11 - API - (AMARIL) - LoginO
// Ambiente: 12 - API - (GUIDE) - LoginA
// Ambiente: 13 - API - (SINGULARE) - LoginS
// Ambiente: 14 - WSO2 - (FAST TRADE - DEMO) - LoginW

// WHITELABEL:

// Ambiente: 1 - API - (CEDRO) -
// Ambiente: 2 - ADAPTER - (PI) - LoginA
// Ambiente: 3 - WSO2 - (RB) - LoginW
// Ambiente: 4 - WSO2 - (CEDRO) - LoginW
// Ambiente: 5 - API (FAST TRADE - DEMO) - LoginS
// Ambiente: 6 - ADAPTER - (DAYCOVAL) - LoginA
// Ambiente: 7 - API - (STONEX) - LoginO
// Ambiente: 8 - WSO2 - (TRINUS) - LoginW
// Ambiente: 9 - ADAPTER - (EMPIRICUS) - LoginA
// Ambiente: 10 - API - (RANKING) - LoginS
// Ambiente: 11 - API - (AMARIL) - LoginO
// Ambiente: 12 - API - (GUIDE) - LoginA
// Ambiente: 13 - API - (SINGULARE) - LoginS
// Ambiente: 14 - WSO2 - (FAST TRADE - DEMO) - LoginW
